import i18n from "@/language"

export const getCommunitySectionTips = (sectionId: string | null) => {
  const key = sectionId || "community-info"
  const tips: string[] = i18n.t(`sectionTips.${key}`, {
    ns: "communities",
    returnObjects: true,
    defaultValue: [],
  }) as unknown as string[]
  return {
    title: i18n.t("tips", { ns: "communities" }) as string,
    tips,
  }
}
